import type { Event } from '@ori-events/open-back-in-stock-notification-dialog';
import { Name } from '@ori-events/open-back-in-stock-notification-dialog';
import { useCallback, useEffect, useState } from 'react';

export const useDialogProps = () => {
  const [productCode, setProductCode] = useState('');
  const [open, setOpen] = useState(false);
  const close = useCallback(() => {
    setOpen(false);
  }, []);

  const successClose = useCallback(() => {
    setTimeout(() => {
      setOpen(false);
    }, 5000);
  }, []);

  useEffect(() => {
    const openDialog = (event: Event): void => {
      const { code } = event.detail;

      setOpen(true);
      setProductCode(code);
    };

    window.addEventListener(Name, openDialog);

    return () => window.removeEventListener(Name, openDialog);
  }, []);

  return {
    open,
    productCode,
    close,
    successClose,
  };
};
